import { render } from "./CreateOrderView.vue?vue&type=template&id=57b05ce8&scoped=true"
import script from "./CreateOrderView.vue?vue&type=script&lang=js"
export * from "./CreateOrderView.vue?vue&type=script&lang=js"

import "./CreateOrderView.vue?vue&type=style&index=0&id=57b05ce8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b05ce8"]])

export default __exports__